import { render, staticRenderFns } from "./ModalPatientMedicalRecord.vue?vue&type=template&id=2f9de726&"
import script from "./ModalPatientMedicalRecord.vue?vue&type=script&lang=js&"
export * from "./ModalPatientMedicalRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports